var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEduplaytionLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eduplaytons_logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "auto",
    viewBox: "0 0 174.826 33.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.024,
    stopColor: "#fff100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#f3be1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f38e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#f37a20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#ee4023"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(34.554 4.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M-1647.772,785.91a6.482,6.482,0,0,0-6.885,6.78c0,4.151,2.654,6.915,7.121,6.915a7.972,7.972,0,0,0,5.571-2.1l-2.05-2.025a5.34,5.34,0,0,1-3.47,1.211c-2.259,0-3.652-1.16-3.861-2.76h10.115C-1640.731,788.592-1643.437,785.91-1647.772,785.91Zm-3.521,5.363a3.489,3.489,0,0,1,3.626-2.525c1.839,0,3.152.842,3.363,2.525Z",
    transform: "translate(1654.657 -780.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M-1590.134,774.682c-.761-1.341-2.889-2.078-4.256-2.078-3.783,0-6.595,2.314-6.595,6.781a6.359,6.359,0,0,0,6.675,6.78,4.709,4.709,0,0,0,4.176-2.077l.211,1.788h3V767.506h-3.207Zm-3.966,8.514a3.642,3.642,0,0,1-3.68-3.81,3.573,3.573,0,0,1,3.68-3.783,3.7,3.7,0,0,1,3.757,3.783A3.672,3.672,0,0,1-1594.1,783.2Z",
    transform: "translate(1615.623 -767.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M-1533.662,793.981a3.406,3.406,0,0,1-3.311,3.626c-2.049,0-3.126-1.5-3.126-3.468v-6.778h-3.206v6.8c0,4.022,2.26,6.359,5.36,6.359a5.763,5.763,0,0,0,4.388-1.943l.211,1.761h2.865V787.361h-3.181Z",
    transform: "translate(1573.675 -781.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-1481.795,786.294a5.149,5.149,0,0,0-4.2,2.076l-.21-1.785h-3V804.95H-1486v-6.935c.919,1.418,2.941,1.843,4.309,1.843,4.152,0,6.542-3,6.542-6.782A6.481,6.481,0,0,0-1481.795,786.294Zm-.237,10.462a3.591,3.591,0,0,1-3.677-3.68,3.514,3.514,0,0,1,3.677-3.679,3.516,3.516,0,0,1,3.68,3.679A3.592,3.592,0,0,1-1482.032,796.756Z",
    transform: "translate(1534.33 -781.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 3.177,
    height: 18.371,
    transform: "translate(60.813 0.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M-1402.948,788.3a4.762,4.762,0,0,0-4.126-2.1c-3.783-.026-6.752,2.314-6.752,6.781,0,4.543,2.833,6.909,6.671,6.883,1.448-.026,3.471-.762,4.207-2.286l.155,1.894h3.022V786.515h-3.07Zm-3.837,8.621a3.712,3.712,0,0,1-3.838-3.941,3.689,3.689,0,0,1,3.838-3.916C-1401.742,789.063-1401.742,796.92-1406.786,796.92Z",
    transform: "translate(1479.51 -780.988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-1350.247,793.038l-1.34,3.573-1.234-3.652-1.975-5.6h-3.729l5.177,12.745-2.419,5.62h3.522l7.906-18.365h-3.544Z",
    transform: "translate(1439.292 -781.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M-1297.09,787.839a1.607,1.607,0,0,1-1.681-1.837v-5.6h3.6v-2.759h-3.573v-3.679l-3.209.341v3.338h-2.415v2.759h2.415V786c0,3.231,1.84,4.835,4.653,4.728a7.145,7.145,0,0,0,2.654-.551l-.9-2.733A3.652,3.652,0,0,1-1297.09,787.839Z",
    transform: "translate(1399.905 -772.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M-1262.937,768.972a1.892,1.892,0,0,0,3.783,0A1.892,1.892,0,0,0-1262.937,768.972Z",
    transform: "translate(1369.775 -767.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 3.205,
    height: 13.008,
    transform: "translate(107.127 5.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-1236.395,786.4a6.483,6.483,0,0,0-6.7,6.753,6.45,6.45,0,0,0,6.727,6.754,6.47,6.47,0,0,0,6.755-6.754A6.551,6.551,0,0,0-1236.395,786.4Zm.026,10.562a3.507,3.507,0,0,1-3.521-3.809,3.557,3.557,0,0,1,3.521-3.835,3.655,3.655,0,0,1,3.52,3.835A3.507,3.507,0,0,1-1236.368,796.961Z",
    transform: "translate(1355.345 -781.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-1180.035,786.591a5.833,5.833,0,0,0-4.257,1.944l-.21-1.762h-2.865v12.983h3.18v-6.624a3.41,3.41,0,0,1,3.31-3.627c2.051,0,3.128,1.5,3.128,3.472v6.779h3.205V792.95C-1174.545,788.876-1176.988,786.591-1180.035,786.591Z",
    transform: "translate(1314.817 -781.275)",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M-1755.863,764.836a2.468,2.468,0,0,1-1.166,3.284l-16.662,9.94h0c-2.681,1.6-2.887-.8-2.894-2.036,0-.039,0-1.494,0-1.494.03.857.335,2.145,2.736.773l14.394-8.371c1.9-1.21,1.9-3.194,0-4.4l-15.487-9.836a5.159,5.159,0,0,0-2.764-.9c-1.814,0-3.645,1.366-3.645,4.419v24.976c0,3.053,1.831,4.419,3.645,4.419h0a5.176,5.176,0,0,0,2.764-.9l19.023-12.108a4.715,4.715,0,0,0,2.414-3.9A4.7,4.7,0,0,0-1755.863,764.836Zm-9.575.743-9.071,5.291c-1.14.665-2.073.2-2.073-1.041V758.914c0-1.239.933-1.708,2.073-1.044l9.071,5.292A1.281,1.281,0,0,1-1765.439,765.579Z",
    transform: "translate(1781.347 -751.793)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduplaytionLogo);
export default __webpack_public_path__ + "static/media/Eduplaytion_Logo.fe677a5c3ceddf27c67ca740c9369820.svg";
export { ForwardRef as ReactComponent };